import { put, takeEvery, call, select } from "redux-saga/effects";

import {
  hideUsersListLoad,
  setErrorUserList,
  setUsersToList,
  showUsersListLoad,
} from "./actions";

import {
  deleteUsers,
  getUsersList,
  addUser,
} from "../../../helpers/jwt_helper";
import {
  getErrorMessage,
  showErrorMessage,
  showSuccessMessage,
} from "../../../helpers/utils";
import {
  ADD_USER_TO_LIST,
  DELETE_USER_FROM_LIST,
  GET_USERS_LIST,
} from "./actionType";

function* onGetUsersList({ payload: data }) {
  try {
    yield put(showUsersListLoad());
    let response = yield call(getUsersList, {
      page: data.page,
      size: data.sizePerPage,
      ordering: data.ordering,
      client: data.client,
      search: data.search,
      positions: data?.position,
      is_active: data?.is_active,
      ...(data?.positions && { positions: data?.positions })
    });

    if (response.results) {
      response = {
        ...data,
        ...response,
        results: response.results.map(i => ({
          ...i,
          created_at: new Date(i.created_at).toDateString(),
        })),
      };
    } else {
      response = {
        results: response,
      };
    }

    yield put(setUsersToList(response));
    yield put(setErrorUserList(false));
    yield put(hideUsersListLoad());
  } catch (error) {
    if (getErrorMessage(error) === "Not found.") {
      yield put(setErrorUserList(true));
    }
    yield put(hideUsersListLoad());
  }
}

function* onAddUser({ payload: { user } }) {
  try {
    let params = {
      password: user.password,
      username: user.username,
      email: user.email,
      first_name: user.first_name,
      last_name: user.last_name,
      phone: user.phone,
      positions: user.positions,
    };
    yield put(showUsersListLoad());
    yield call(addUser, params);
    showSuccessMessage(
      `User ${user.first_name} ${user.last_name} has been added successfully`
    );
    yield call(onGetUsersList, {
      payload: yield select(state => state.UsersList.data),
    });
    yield put(hideUsersListLoad());
  } catch (e) {
    yield put(hideUsersListLoad());
    getErrorMessage(showErrorMessage(e));
  }
}

function* onDeleteUser({ payload: { id, data } }) {
  try {
    yield put(showUsersListLoad());
    yield call(deleteUsers, id);
    yield call(onGetUsersList, { payload: data });
    yield put(hideUsersListLoad());
    showSuccessMessage(`User has been deleted successfully`);
  } catch (error) {
    yield put(hideUsersListLoad());
    getErrorMessage(showErrorMessage(error));
    showErrorMessage(getErrorMessage(error));
  }
}

function* usersListSaga() {
  yield takeEvery(GET_USERS_LIST, onGetUsersList);
  yield takeEvery(DELETE_USER_FROM_LIST, onDeleteUser);
  yield takeEvery(ADD_USER_TO_LIST, onAddUser);
}

export default usersListSaga;
